import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { UserService, TopUpData } from '../../services/user.service';

@Component({
  selector: 'app-top-up',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './top-up.component.html',
  styleUrls: ['./top-up.component.css'],
})
export class TopUpComponent implements OnInit {
  @Output() topUpComplete = new EventEmitter<{
    balance: number;
    receiptSent?: boolean;
    paymentMethod?: string;
  }>();

  topUpForm!: FormGroup;
  isSubmitting = false;
  errorMessage = '';
  successMessage = '';

  paymentMethods = [
    { id: 'card', name: 'Card' },
    { id: 'bankTransfer', name: 'Bank Transfer' },
    { id: 'phone', name: 'Phone' },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.topUpForm = this.formBuilder.group({
      amount: ['', [Validators.required, Validators.min(0.01)]],
      paymentMethod: ['card', Validators.required],
    });
  }

  onSubmit(): void {
    if (this.topUpForm.invalid) {
      Object.keys(this.topUpForm.controls).forEach((key) => {
        const control = this.topUpForm.get(key);
        control?.markAsTouched();
      });
      return;
    }

    this.isSubmitting = true;
    this.errorMessage = '';
    this.successMessage = '';

    const topUpData: TopUpData = {
      amount: parseFloat(this.topUpForm.value.amount),
      paymentMethod: this.topUpForm.value.paymentMethod,
    };

    this.userService.topUpBalance(topUpData).subscribe({
      next: (result) => {
        this.isSubmitting = false;
        const newBalance =
          typeof result.balance === 'string'
            ? parseFloat(result.balance)
            : result.balance;

        let baseMessage = `Successfully added $${topUpData.amount.toFixed(
          2
        )} to your balance. New balance: $${newBalance.toFixed(2)}`;

        if (result.receiptSent) {
          this.successMessage = `${baseMessage}. A receipt has been sent to your email.`;
        } else {
          this.successMessage = baseMessage;
        }

        this.topUpForm.reset({ paymentMethod: 'card' });
        this.topUpComplete.emit({
          balance: newBalance,
          receiptSent: result.receiptSent,
          paymentMethod: result.paymentMethod,
        });
      },
      error: (error) => {
        this.isSubmitting = false;
        this.errorMessage =
          error.message || 'Failed to top up balance. Please try again.';
      },
    });
  }
}
